import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "partner-page" }
const _hoisted_2 = { class: "container header-padding-compensation" }
const _hoisted_3 = { class: "partner-card-container" }
const _hoisted_4 = { class: "container header-padding-compensation" }
const _hoisted_5 = { class: "row placeholder-glow" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "partner-image-background animate__animated animate__fadeInLeft" }
const _hoisted_8 = { class: "partner-image-container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["srcset"]
const _hoisted_12 = ["srcset"]
const _hoisted_13 = ["srcset"]
const _hoisted_14 = ["srcset"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "partner-info" }
const _hoisted_19 = { class: "partner-headline" }
const _hoisted_20 = {
  key: 1,
  class: "partner-info"
}
const _hoisted_21 = { class: "partner-headline" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "partner-products" }
const _hoisted_24 = { class: "container header-padding-compensation" }
const _hoisted_25 = { class: "bl dline section-headline" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "row placeholder-glow" }
const _hoisted_28 = { class: "col-lg-3 mb-3" }
const _hoisted_29 = { class: "col-lg-3 mb-3" }
const _hoisted_30 = { class: "col-lg-3 mb-3" }
const _hoisted_31 = { class: "col-lg-3 mb-3" }
const _hoisted_32 = { class: "col-lg-3" }
const _hoisted_33 = { class: "col-lg-3" }
const _hoisted_34 = { class: "col-lg-3" }
const _hoisted_35 = { class: "col-lg-3" }
const _hoisted_36 = {
  key: 1,
  class: "products-container"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6 col-lg-4 col-xl-3 position-relative" }
const _hoisted_39 = { class: "coming-soon-text" }
const _hoisted_40 = { class: "image-container" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "gradient-background" }, null, -1)
const _hoisted_42 = ["srcset"]
const _hoisted_43 = ["srcset"]
const _hoisted_44 = ["srcset"]
const _hoisted_45 = ["srcset"]
const _hoisted_46 = ["alt", "src"]
const _hoisted_47 = { class: "price-container" }
const _hoisted_48 = { class: "product-price" }
const _hoisted_49 = {
  key: 0,
  class: "subscription-activation"
}
const _hoisted_50 = ["id"]
const _hoisted_51 = { class: "mb-2" }
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "btn btn-outline-dark" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-right-arrow" }, null, -1)
const _hoisted_57 = ["id"]
const _hoisted_58 = { class: "product-name" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_placeholder = _resolveComponent("b-placeholder")!
  const _component_truncate = _resolveComponent("truncate")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_popover = _resolveComponent("b-popover")!
  const _component_GiftCardGirlBanner = _resolveComponent("GiftCardGirlBanner")!
  const _component_SellingPoints = _resolveComponent("SellingPoints")!
  const _component_SubscriptionsBanner = _resolveComponent("SubscriptionsBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_breadcrumb, { items: _ctx.BreadcrumbsItems }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_b_placeholder, {
                        class: "placeholder",
                        width: "100%",
                        style: {"height":"485px"}
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("picture", _hoisted_10, [
                      _createElementVNode("source", {
                        media: "only screen and (min-width: 1200px)",
                        srcset: _ctx.$imgix(_ctx.PhotoUrl,'?w=485&h=485&auto=compress,format&fit=crop')
                      }, null, 8, _hoisted_11),
                      _createElementVNode("source", {
                        media: "only screen and (min-width: 992px)",
                        srcset: _ctx.$imgix(_ctx.PhotoUrl,'?w=485&h=485&auto=compress,format&fit=crop')
                      }, null, 8, _hoisted_12),
                      _createElementVNode("source", {
                        media: "only screen and (min-width: 768px)",
                        srcset: _ctx.$imgix(_ctx.PhotoUrl,'?w=485&h=485&auto=compress,format&fit=crop')
                      }, null, 8, _hoisted_13),
                      _createElementVNode("source", {
                        media: "only screen and (min-width: 576px)",
                        srcset: _ctx.$imgix(_ctx.PhotoUrl,'?w=350&h=350&auto=compress,format&fit=crop')
                      }, null, 8, _hoisted_14),
                      _createElementVNode("img", {
                        src: _ctx.$imgix(_ctx.PhotoUrl,'?w=350&h=350&auto=compress,format&fit=crop'),
                        class: "image-container",
                        alt: _ctx.PartnerName,
                        width: "350",
                        height: "350"
                      }, null, 8, _hoisted_15)
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (!_ctx.ready)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_b_placeholder, {
                        class: "placeholder",
                        width: "100%",
                        style: {"height":"50px"}
                      })
                    ])
                  ]),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "100%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "85%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "90%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "95%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-3",
                    width: "55%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "90%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "100%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "95%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "85%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-4",
                    width: "100%",
                    style: {"height":"16px"}
                  }),
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder mb-2",
                    width: "25%",
                    style: {"height":"50px","padding":"0.75rem 5rem"}
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.PartnerName), 1),
                  _createVNode(_component_truncate, {
                    text: _ctx.PartnerDescription,
                    length: 540,
                    actionClass: 'btn btn-outline-dark mt-4',
                    clamp: _ctx.$t('general.read-more'),
                    less: _ctx.$t('general.read-less'),
                    type: "html"
                  }, null, 8, ["text", "clamp", "less"])
                ])),
            (_ctx.HasActiveSquashSubscripton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$goToBookingCourts && _ctx.$goToBookingCourts(...args))),
                    class: "btn btn-primary mt-4"
                  }, _toDisplayString(_ctx.$t('website.book-lane')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('website.partner-products')), 1),
        (!_ctx.ready)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_b_placeholder, {
                    class: "placeholder",
                    width: "100%",
                    style: {"height":"270px"}
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ProductList, (product, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    (product.IsComingSoon)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["coming-soon-container animate__animated animate__fadeInUpSmall", 'product_animate_delay_' + index])
                        }, [
                          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('website.coming-soon')), 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(['product_animate_delay_' + index, "product-container animate__animated animate__fadeInUpSmall"])
                    }, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_router_link, {
                          to: _ctx.getRouterOptions(product)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_41
                          ], undefined, true),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("picture", null, [
                          _createElementVNode("source", {
                            media: "only screen and (min-width: 1200px)",
                            srcset: _ctx.$imgix(product.PhotoUrl,'?w=255&h=270&auto=compress,format&fit=crop')
                          }, null, 8, _hoisted_42),
                          _createElementVNode("source", {
                            media: "only screen and (min-width: 992px)",
                            srcset: _ctx.$imgix(product.PhotoUrl,'?w=290&h=270&auto=compress,format&fit=crop')
                          }, null, 8, _hoisted_43),
                          _createElementVNode("source", {
                            media: "only screen and (min-width: 768px)",
                            srcset: _ctx.$imgix(product.PhotoUrl,'?w=690&h=270&auto=compress,format&fit=crop')
                          }, null, 8, _hoisted_44),
                          _createElementVNode("source", {
                            media: "only screen and (min-width: 576px)",
                            srcset: _ctx.$imgix(product.PhotoUrl,'?w=510&h=270&auto=compress,format&fit=crop')
                          }, null, 8, _hoisted_45),
                          _createElementVNode("img", {
                            alt: product.Name,
                            src: _ctx.$imgix(product.PhotoUrl,'?w=510&h=270&auto=compress,format&fit=crop'),
                            width: "510",
                            height: "270"
                          }, null, 8, _hoisted_46)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('website.price-currency', {price: _ctx.$n(product.Price, 'decimal', 'FR') , currency: 'kr' })), 1)
                        ]),
                        (!product.IsComingSoon)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              (product.IsActiveSubscribe && !product.SubscriptionId)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: { name: 'MyPage', hash: '#Abonnementer', params: { propProductCategoryId: product.Id, unsubscribe: true } },
                                    "aria-label": "Subscribe",
                                    class: "activate-subscription-button active"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('website.activate-subscription')), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true),
                              (product.IsActiveSubscribe && product.SubscriptionId)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    id: `popover-trigger-${product.Id}`,
                                    "aria-label": "Subscribe",
                                    class: "activate-subscription-button active"
                                  }, _toDisplayString(_ctx.$t('website.activate-subscription')), 9, _hoisted_50))
                                : _createCommentVNode("", true),
                              (!product.IsActiveSubscribe)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 2,
                                    to: { name: 'CheckOut', params: { productId: product.Id } },
                                    class: "activate-subscription-button"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('website.activate-subscription')), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_b_popover, {
                          target: `popover-trigger-${product.Id}`,
                          placement: 'top',
                          prefix: "info",
                          triggers: "click",
                          content: _ctx.$t('website.password-requirements'),
                          "custom-class": "unsubscribe-popover",
                          show: product.isPopoverVisible,
                          "onUpdate:show": ($event: any) => ((product.isPopoverVisible) = $event),
                          variant: _ctx.popoverOptions.popoverVariant
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('website.do-you-want-to-deactivate')) + "?", 1),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.unSubscribe(product)),
                                class: "btn btn-outline-dark btn-sm btn-popover me-2"
                              }, _toDisplayString(_ctx.$t('general.yes')), 9, _hoisted_53),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (product.isPopoverVisible = false),
                                class: "btn btn-outline-dark btn-sm btn-popover"
                              }, _toDisplayString(_ctx.$t('general.no')), 9, _hoisted_54)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["target", "content", "show", "onUpdate:show", "variant"]),
                        _createVNode(_component_router_link, {
                          class: "image-hover-container",
                          to: _ctx.getRouterOptions(product)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", _hoisted_55, [
                              _createTextVNode(_toDisplayString(_ctx.$t('website.see-product')) + " ", 1),
                              _hoisted_56
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createVNode(_component_router_link, {
                        to: _ctx.getRouterOptions(product)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "product-description-container",
                            id: `popover-trigger-description-${product.Id}`
                          }, [
                            _createElementVNode("p", _hoisted_58, _toDisplayString(product.Name), 1),
                            _createElementVNode("p", {
                              innerHTML: product.ShortDescription,
                              class: "product-description"
                            }, null, 8, _hoisted_59)
                          ], 8, _hoisted_57)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_b_popover, {
                        target: `popover-trigger-description-${product.Id}`,
                        placement: 'top',
                        prefix: "info",
                        triggers: "hover",
                        "custom-class": "product-description-popover",
                        variant: _ctx.popoverOptions.popoverVariant
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            innerHTML: product.ShortDescription
                          }, null, 8, _hoisted_60)
                        ]),
                        _: 2
                      }, 1032, ["target", "variant"])
                    ], 2)
                  ]))
                }), 256))
              ])
            ]))
      ])
    ]),
    _createVNode(_component_GiftCardGirlBanner),
    _createElementVNode("section", null, [
      _createVNode(_component_SellingPoints)
    ]),
    _createVNode(_component_SubscriptionsBanner)
  ]))
}